/** @format */

import { UIRow, UICol, UIText, UIInput } from "@rstore-react-packages/template-ui";
import { Button, Form } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { actionMassiveStoreStatusRequest } from "../../../../redux-modules/actions/actionsStore";
import { useLanguage } from "../../../../redux-modules/hooks/useLanguage";
import StyledModal from "../../../ui/Modal";

/** @format */
interface Props {
  visible: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  store: number[];
}
const ModalChangeStoreStatus = ({
  visible = false,
  handleCancel,
  handleOk,
  store,
}: Props): JSX.Element => {
  const l = useLanguage();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [canDelete, setCanDelete] = useState(false);
  const [typedValue, setTypedValue] = useState("");

  const handleFinish = (form): void => {
    dispatch(
      actionMassiveStoreStatusRequest({
        users_ids: store,
        action: "delete",
      }),
    );
    //@ts-ignore
    handleOk && handleOk();
  };

  const handleReturn = (): void => {
    handleCancel && handleCancel();
  };

  useEffect(() => {
    if (typedValue === "delete stores") setCanDelete(true);
    else setCanDelete(false);
  }, [typedValue]);

  return (
    <StyledModal
      title={l("delete")}
      visible={visible}
      //@ts-ignore
      canDelete={canDelete}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleReturn}>
          Return
        </Button>,
        <Button key="submit" disabled={!canDelete} onClick={(): void => form.submit()}>
          Submit
        </Button>,
      ]}
    >
      <UIRow>
        <UICol xs={24}>
          <Form form={form} name="edit-store-status" layout="inline" onFinish={handleFinish}>
            <UIText>{"You are deleting " + store.length + " stores."}</UIText>
          </Form>
        </UICol>
      </UIRow>
      <UIRow style={{ marginTop: "10px" }}>
        <UIText>To confirm the operation type "delete stores":</UIText>
        <UIInput onChange={(e): void => setTypedValue(e.target.value)} />
      </UIRow>
    </StyledModal>
  );
};
export default ModalChangeStoreStatus;
